import { FC } from 'react';
import BulkActions from '../BulkActions';
import { LocalAccount } from '../../types/LocalAccount';
import useLocalAccountBulkActions from './hooks/useLocalAccountBulkActions';

interface LocalAccountsBulkActionsProps {
    onClose: () => void;
    selectedAccounts: LocalAccount[];
    onActionSuccess: () => void;
}

const LocalAccountsBulkActions: FC<LocalAccountsBulkActionsProps> = ({
    selectedAccounts,
    onClose,
    onActionSuccess
}) => {
    const { actions } = useLocalAccountBulkActions({ selectedAccounts, onClose, onActionSuccess });

    return (
        <BulkActions
            selectedItems={selectedAccounts}
            onClose={onClose}
            actions={actions}
            selectionText={{ singular: 'account', plural: 'accounts' }}
        />
    );
};

export default LocalAccountsBulkActions;
